/*
 * LEGACY - Expanding Blocks JS
 */
window.addEventListener('DOMContentLoaded', function () {
	/**
	 * Sticky nav trigger for mobile table of contents
	 */
	var tocBlock = document.querySelector('.sticky-subnav .wp-block-rank-math-toc-block');
	if (tocBlock) {
		tocBlock.addEventListener('click', function (event) {
			var target = event.target;
			// Check if the clicked element or its ancestors contain the 'open' class
			if (target.classList.contains('open') || tocBlock.classList.contains('open')) {
				tocBlock.classList.remove('open');
			} else {
				tocBlock.classList.add('open');
				tocBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		});
	}

	/**
	 * Accordion open/close with class .accordion-faq--variation
	 */
	const allAccordionFAQs = document.getElementsByClassName('accordion-faq--variation');
	for (const accordionFAQ of allAccordionFAQs) {
		// if the .accordion-title block is clicked, toggle the parent class .open
		const accordionTitle = accordionFAQ.querySelector('.accordion-title');
		if (accordionTitle) {
			accordionTitle.addEventListener('click', function () {
				accordionFAQ.classList.toggle('open');
			});
		}
	}

	/**
	 * Loop through ALL expanding blocks
	 */
	const allExpandingBlocks = document.getElementsByClassName('expanding-block-pattern');
	for (const expandingBlock of allExpandingBlocks) {
		const expandingTitle = expandingBlock.querySelector('.expanding-trigger');
		if (expandingTitle) {
			// Toggle open
			expandingTitle.addEventListener('click', function () {
				expandingBlock.classList.toggle('closed');
				// also scroll to the top of the expanding block
				expandingTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		}
	}
});
